module.exports = __webpack_public_path__ + "static/media/logo-unidas.f3eee5a1.png";